import Api from '../api';

const PRODUCT_TYPE_WEBSITE = 'website';

export default {
    validateCryptoAddress({ language, ...jsonData }) {
        return this._post('v1/webwallet/validate_crypto_address', jsonData, {
            headers: {
                'X-User-Locale': language,
            },
        });
    },

    getNotifications(params = {}) {
        return this._get('v1/users/notifications', {
            ...params,
            businessAccountProductId: BUSINESS_ACCOUNT_PRODUCT_ID, // eslint-disable-line no-undef
        });
    },

    getNotificationsUnreadCount(params = {}) {
        return this._get('v1/users/notifications/unread-count', {
            ...params,
            businessAccountProductId: BUSINESS_ACCOUNT_PRODUCT_ID, // eslint-disable-line no-undef
        });
    },

    markNotificationsAsReadByIds(ids = []) {
        return this._post('v1/users/notifications/read', {
            notificationIds: ids,
            businessAccountProductId: BUSINESS_ACCOUNT_PRODUCT_ID, // eslint-disable-line no-undef
        });
    },

    getTransactions(TransactionFilterBuilder, { page, pageSize }) {
        return this._get('v1/user-transaction', {
            ...TransactionFilterBuilder.getFormatted(),
            page,
            pageSize,
            productType: PRODUCT_TYPE_WEBSITE,
        });
    },

    getTransactionsByLimit(limit) {
        return this._get('v1/user-transaction', {
            pageSize: limit,
            productType: PRODUCT_TYPE_WEBSITE,
        });
    },

    getUser() {
        return this._get('v1/users/me');
    },

    saveUserDecisionAfterInvitationPopUp(decision) {
        return this._patch('v1/users/stay-in-app-terms', {
            stayInApp: decision,
        });
    },

    getExchangeLinksByAssets(assetIds) {
        return this._get('v1/wallet/asset/options', {
            assetIds,
        }).then(({ data }) => data);
    },

    addTransactionBeneficiaryData(invoice, data) {
        return this._post(`v1/transaction/${invoice}/data/beneficiary`, data);
    },

    addTransactionOriginatorData(invoice, data) {
        return this._post(`v1/transaction/${invoice}/data/originator`, data);
    },

    _patch(path, jsonData) {
        return Api()
          .patch(this._getApiUrl(path), jsonData);
    },

    _get(path, params) {
        return Api()
            .get(this._getApiUrl(path), { params })
            .then(({ data }) => data);
    },

    _post(path, jsonData, params) {
        return Api()
            .post(this._getApiUrl(path), jsonData, params);
    },

    _getApiUrl(path) {
        const rootUrl = PROCESSING_API_URL; // eslint-disable-line no-undef

        return `${rootUrl}/public/processing/${path}`;
    },
};
